export default "__VITE_ASSET__NSaLJLrY__"